"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var find_1 = tslib_1.__importDefault(require("lodash/find"));
var programActions = tslib_1.__importStar(require("../programs/actions"));
var programSelectors = tslib_1.__importStar(require("../programs/selectors"));
var api_1 = require("./api");
var selectors_1 = require("./selectors");
var action_types_1 = require("./action-types");
/*******************************************************************
 * Action Creators
 *******************************************************************/
exports.unloadProgressData = function () { return ({ type: action_types_1.UNLOAD_PROGRESS_DATA }); };
exports.setParticipantProgress = function (paxProgress) { return ({ type: action_types_1.SET_PARTICIPANT_PROGRESS, paxProgress: paxProgress }); };
exports.setPaxPlanData = function (paxPlanData) { return ({ type: action_types_1.SET_PAX_PLAN_DETAILS, paxPlanData: paxPlanData }); };
exports.setNoSavedMsg = function () { return ({ type: action_types_1.NO_SAVED_MSG }); };
exports.addPlan = function (paxPlanSets) { return ({ type: action_types_1.ADD_PLAN, paxPlanSets: paxPlanSets }); };
exports.updateActionStep = function (planIndex, index, value, completed) { return ({
    type: action_types_1.ACTION_STEP_UPDATED,
    planIndex: planIndex,
    index: index,
    value: value,
    completed: completed
}); };
exports.updatePlan = function (planIndex, positive, obstacle, updateObstacleAndPostive) { return ({
    type: action_types_1.PLAN_UPDATED,
    planIndex: planIndex,
    positive: positive,
    obstacle: obstacle,
    updateObstacleAndPostive: updateObstacleAndPostive
}); };
exports.setProgramViewProgressData = function (programViewId, progressData) { return ({
    type: action_types_1.SET_VIEW_PROGRESS_DATA,
    progressData: progressData,
    programViewId: programViewId
}); };
exports.fetchProgramViewProgress = function (programViewId) { return function (dispatch, getState) {
    console.warn('DEPRECATED: progress fetch is now part of the contest endpoint');
    return api_1.getProgramViewProgress(programViewId)
        .then(function (progressData) { return dispatch(exports.setProgramViewProgressData(programViewId, progressData)); });
}; };
exports.fetchParticipantProgress = function (options) {
    if (options === void 0) { options = {}; }
    return function (dispatch, getState) {
        console.warn('DEPRECATED: progress fetch is now part of the contest endpoint');
        var skipLegacyProgressData = options.skipLegacyProgressData, program = options.program;
        if (!program) {
            throw new Error('`fetchParticipantProgress` action requires a program to be passed in the options');
        }
        dispatch(exports.unloadProgressData());
        var state = getState();
        var userId = state.user.userId;
        if (userId) {
            return Promise.all([
                dispatch(exports.fetchProgramViewProgress(program.programViewId)),
                !skipLegacyProgressData && api_1.fetchPlanData(program, userId).then(function (progress) {
                    if (progress) {
                        return dispatch(exports.setParticipantProgress(progress));
                    }
                    return Promise.resolve();
                })
            ]);
        }
        return Promise.resolve();
    };
};
exports.setProgramViewTableData = function (programViewId, orgUnitId, tableData) { return ({
    type: action_types_1.SET_VIEW_ORG_TABLE_DATA,
    programViewId: programViewId,
    orgUnitId: orgUnitId,
    tableData: tableData
}); };
exports.fetchProgramViewTables = function (programViewId, orgUnitId) {
    if (orgUnitId === void 0) { orgUnitId = undefined; }
    return function (dispatch) {
        if (!orgUnitId) {
            return dispatch(exports.fetchProgramViewProgress(programViewId));
        }
        return api_1.getProgramViewTables(programViewId, orgUnitId)
            .then(function (tableData) { return dispatch(exports.setProgramViewTableData(programViewId, orgUnitId, tableData)); });
    };
};
exports.pushOrgItemHierarchy = function (programViewId, id, name) { return ({
    type: action_types_1.ADD_VIEW_ORG_HIERARCHY,
    programViewId: programViewId,
    orgUnit: { id: id, name: name }
}); };
exports.popOrgItemHierarchy = function (programViewId, orgUnitId) {
    if (orgUnitId === void 0) { orgUnitId = undefined; }
    return ({
        type: action_types_1.SLICE_VIEW_ORG_HIERARCHY,
        programViewId: programViewId,
        orgUnitId: orgUnitId
    });
};
/*
    The api is not restful and follows some weird rules
    1) if all of the actionSteps are empty along with the obstacle and positive
       the api will remove the plan set
    2) any extraneous fields will cause the api to barf, only send what is recieved from
       the api
    3) adding an actionStep to the payload will cause the api to treat it like a POST and
       return an id with the new action step
    4) If the fields are empty but you add a new action step, the api will ignore it
       and just return the default state, or if the planset has an ID, it will treat
       it like a DELETE
*/
exports.addActionStep = function (planSetId) { return function (dispatch, getState) {
    var state = getState();
    var planData = api_1.serializePlanData(selectors_1.getPlanData(state));
    var planSet = find_1.default(planData.goalQuestMyPlanVOs, function (plan) { return plan.id === planSetId; });
    console.assert(planSet, "Could not find a plan set with the id " + planSetId);
    planSet.actionSteps = tslib_1.__spread(planSet.actionSteps, [{
            actionStep: '',
            actionStepStatus: false
        }]);
    return api_1.postPlanProgress(planData).then(function (plan) {
        if (plan) {
            dispatch(exports.setPaxPlanData(plan));
            dispatch(exports.setNoSavedMsg());
        }
    });
}; };
exports.savePaxPlanSets = function () { return function (dispatch, getState) {
    var state = getState();
    return api_1.postPlanProgress(api_1.serializePlanData(selectors_1.getPlanData(state))).then(function (plan) {
        if (plan) {
            dispatch(exports.setPaxPlanData(plan));
            dispatch(exports.setNoSavedMsg());
        }
    });
}; };
exports.deletePlanSet = function (planSetId) { return function (dispatch, getState) {
    var state = getState();
    var planData = api_1.serializePlanData(selectors_1.getPlanData(state));
    var planSet = find_1.default(planData.goalQuestMyPlanVOs, function (plan) { return plan.id === planSetId; });
    console.assert(planSet, "Could not find a plan set with the id " + planSetId);
    planSet.obstacle = '';
    planSet.positive = '';
    planSet.actionSteps = [];
    return api_1.postPlanProgress(planData).then(function (plan) {
        if (plan) {
            dispatch(exports.setPaxPlanData(plan));
            dispatch(exports.setNoSavedMsg());
        }
    });
}; };
var goalIsSaving = false;
exports.saveGoal = function (programViewId, payoutTierId) { return function (dispatch, getState) {
    if (!goalIsSaving) {
        goalIsSaving = true;
        var program = programSelectors.getProgram(getState(), programViewId) || {};
        var goal = selectors_1.getProgramViewGoal(getState(), programViewId) || {};
        var postData = {
            payoutTierId: payoutTierId,
            productId: goal.productId,
            paxGoalId: program.paxGoalId,
            groupId: program.groupId,
            programId: program.programId,
            timePeriodId: program.timePeriodId || null // coerce a 0 to null to account for inconsistent api
        };
        return api_1.postGoal(postData)
            .catch(function (err) {
            goalIsSaving = false;
            throw err;
        })
            .then(function () {
            goalIsSaving = false;
            return Promise.all([
                dispatch(exports.fetchProgramViewProgress(programViewId)),
                dispatch(programActions.getProgramView(programViewId))
            ]);
        });
    }
    return Promise.resolve();
}; };
//# sourceMappingURL=actions.js.map